<template>
  <div class="analysis">
    <v-card flat="flat" class="nuclear parent">
      <v-card-title class="parent">Configuration / Analysis</v-card-title>
      <v-card-text class="parent">
        <v-card class="child">
          <div class="container">
            <v-card-title class="child">Latest Uploads & Reports</v-card-title>
            <v-card-text class="child">
              <div
                v-if="loading == true"
                style="margin-left: 45%; margin-top: 50px; margin-bottom: 50px;"
              >
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="teal"
                  indeterminate
                ></v-progress-circular>
              </div>
              <v-data-table
                :headers="headers"
                :items="items"
                :hide-default-footer="true"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                :disable-pagination="true"
                item-key="id"
                show-expand
                v-else
              >
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length - 1" class="expand_item">
                    <v-row class="not_mobile">
                      <v-col cols="12" sm="4" md="2" lg="1" v-if="profile.role != 4">
                        <v-row justify="center">
                          <v-dialog
                            v-model="deletedialog"
                            persistent
                            max-width="320"
                          >
                            <template v-slot:activator="{ on }">
                              <div class="action" v-on="on">
                                <font-awesome-icon
                                  class="delete"
                                  icon="trash-alt"
                                />
                                <p>Delete</p>
                              </div>
                            </template>
                            <v-card class="modal">
                              <v-card-title>
                                <font-awesome-icon
                                  class="delete_header"
                                  icon="info-circle"
                                />
                                <p>File Delete Confirmation</p>
                              </v-card-title>
                              <v-card-text>
                                <p>
                                  Are you sure you want to
                                  <span class="bold">delete</span> this file
                                  <span class="bold">forever</span>?
                                </p>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  small
                                  class="delete"
                                  @click="deleteAnalysis(item)"
                                  >Yes</v-btn
                                >
                                <v-btn
                                  small
                                  class="cancel"
                                  @click="deletedialog = false"
                                  >No</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="4" md="2" lg="1">
                        <v-dialog
                          v-model="sharedialog"
                          persistent
                          max-width="300px"
                        >
                          <template v-slot:activator="{ on }">
                            <div class="action" v-on="on">
                              <font-awesome-icon class="share" icon="share" />
                              <p>Share</p>
                            </div>
                          </template>
                          <v-card class="modal">
                            <v-card-title class="modal">
                              Share Report
                              <v-btn class="mx-2" icon small @click="sharedialog = false" style="position: absolute; right: 5px;">
                                <v-icon color="red">mdi-close-circle</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-card-text class="modal">
                              <p>Type in emails separated by a comma.</p>
                              <v-form
                                v-model="valid"
                                ref="form"
                                lazy-validation
                              >
                                <textarea
                                  id="message"
                                  rows="10"
                                  v-model="shareemails"
                                  required
                                ></textarea>
                              </v-form>
                              <p>{{sharestatus}}</p>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn
                                small
                                class="save"
                                @click="shareReport(item)"
                                >Share</v-btn
                              >
                              <v-btn
                                small
                                class="cancel"
                                @click="sharedialog = false"
                                >Cancel</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-col>
                      <v-col cols="12" sm="4" md="2" lg="1">
                        <div class="action">
                          <router-link
                            :to="{ name: 'report', params: { id: item.id } }"
                          >
                            <p>
                              <font-awesome-icon class="view" icon="eye" /><span
                                >View</span
                              >
                            </p>
                          </router-link>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mobile">
                      <v-dialog
                        v-model="deletedialog_mobile"
                        persistent
                        max-width="320"
                      >
                        <template v-slot:activator="{ on }">
                          <div class="action" v-on="on">
                            <font-awesome-icon
                              class="delete"
                              icon="trash-alt"
                            />
                            <p>Delete</p>
                          </div>
                        </template>
                        <v-card class="modal">
                          <v-card-title>
                            <font-awesome-icon
                              class="delete_header"
                              icon="info-circle"
                            />
                            <p>File Delete Confirmation</p>
                          </v-card-title>
                          <v-card-text
                            >Are you sure you want to
                            <span class="bold">delete</span> this file
                            <span class="bold">forever</span>?</v-card-text
                          >
                          <v-card-actions>
                            <v-btn
                              small
                              class="delete"
                              @click="deleteAnalysis(item)"
                              >Yes</v-btn
                            >
                            <v-btn
                              small
                              class="cancel"
                              @click="deletedialog_mobile = false"
                              >No</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-model="sharedialog_mobile"
                        persistent
                        max-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <div class="action" v-on="on">
                            <font-awesome-icon class="share" icon="share" />
                            <p>Share</p>
                          </div>
                        </template>
                        <v-card class="modal">
                          <v-card-title class="modal"
                            >Share Report</v-card-title
                          >
                          <v-card-text class="modal">
                            <p>Type in emails separated by comma.</p>
                            <v-form v-model="valid" ref="form" lazy-validation>
                              <textarea
                                id="message"
                                rows="10"
                                v-model="shareemails"
                                required
                              ></textarea>
                            </v-form>
                            <p>{{sharestatus}}</p>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn small class="save" @click="shareReport(item)"
                              >Share</v-btn
                            >
                            <v-btn
                              small
                              class="cancel"
                              @click="sharedialog_mobile = false"
                              >Cancel</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <div class="action">
                        <router-link to="/report">
                          <p>
                            <font-awesome-icon class="view" icon="eye" /><span
                              >View</span
                            >
                          </p>
                        </router-link>
                      </div>
                    </v-row>
                  </td>
                </template>
                <template v-slot:item.index="{ item }">
                  <div class="original">{{ item.index }}</div>
                  <div class="mobile">
                    <div>{{ item.index }}</div>
                    <div class="description">{{ item.description }}</div>
                    <div v-if="item.status == 'Processing'" class="process">
                      {{ item.status }}
                    </div>
                    <div v-if="item.status == 'Completed'" class="complete">
                      Complete
                    </div>
                  </div>
                </template>
                <template v-slot:item.description="{ item }">
                  <div class="description">{{ item.description }}</div>
                </template>
                <template v-slot:item.status="{ item }">
                  <div v-if="item.status == 'Processing'" class="process">
                    {{ item.status }}
                  </div>
                  <div v-if="item.status == 'Completed'" class="complete">
                    Complete
                  </div>
                </template>
                <template v-slot:item.vendor="{ item }">
                  <div class="original">{{ item.vendor }}</div>
                  <div class="mobile">
                    <div>{{ item.vendor }}</div>
                    <div>{{ item.submitted }}</div>
                  </div>
                </template>
                <template v-slot:item.submitted="{ item }">
                  <div>{{ item.submitted }}</div>
                </template>
                <template v-slot:item.risk_rating="{ item }">
                  <font-awesome-icon
                    class="risk_rating critical original"
                    icon="circle"
                    v-if="item.risk_rating == 1"
                  />
                  <font-awesome-icon
                    class="risk_rating high original"
                    icon="circle"
                    v-if="item.risk_rating == 2"
                  />
                  <font-awesome-icon
                    class="risk_rating medium original"
                    icon="circle"
                    v-if="item.risk_rating == 3"
                  />
                  <font-awesome-icon
                    class="risk_rating low original"
                    icon="circle"
                    v-if="item.risk_rating == 4"
                  />
                  <div class="mobile">
                    <font-awesome-icon
                      class="risk_rating critical"
                      icon="circle"
                      v-if="item.risk_rating == 1"
                    />
                    <font-awesome-icon
                      class="risk_rating high"
                      icon="circle"
                      v-if="item.risk_rating == 2"
                    />
                    <font-awesome-icon
                      class="risk_rating medium"
                      icon="circle"
                      v-if="item.risk_rating == 3"
                    />
                    <font-awesome-icon
                      class="risk_rating low"
                      icon="circle"
                      v-if="item.risk_rating == 4"
                    />
                    <font-awesome-icon
                      class="report"
                      icon="ellipsis-h"
                      @click="expandOnMobile"
                    />
                  </div>
                </template>
                <template v-slot:item.report>
                  <font-awesome-icon
                    class="report"
                    icon="ellipsis-h"
                    @click="expandOnDesktop"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </div>
        </v-card>
      </v-card-text>
      <div class="anaylsis_graph">
        <div class="action_group">
          <div class="graph_icon"></div>
          <font-awesome-icon
            class="down"
            icon="chevron-down"
            @click="ShowGraph"
          />
        </div>
        <div class="graph" v-if="showgraph == true">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="5">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="5">
                  <h3>Overall Risk Distribution</h3>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="7">
                  <apexchart
                    type="donut"
                    height="200"
                    :options="riskOptions"
                    :series="risks"
                    class="risk"
                    v-if="risks.length > 0"
                  />
                  <span v-else>No data available</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="5">
                  <h3>Overall Vendor Finding Distribution</h3>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="7">
                  <apexchart
                    type="donut"
                    height="200"
                    :options="vendorOptions"
                    :series="vendors"
                    class="vendor"
                    v-if="vendors.length > 0"
                  />
                  <span v-else>No data available</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="1" class="requirement">
              <v-row>
                <v-col cols="12" sm="6" md="12" lg="12">
                  <div class="critical">
                    <div class="number">{{ this.criticalCount }}</div>
                    <div class="arrow-up"></div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="12" lg="12">
                  <p>
                    Immediate
                    <span class="bold">Critical Remediation</span> Required
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expanded: [],
      singleExpand: true,
      headers: [
        { text: "No", align: "center", sortable: false, value: "index" },
        {
          text: "DESCRIPTION",
          align: "left",
          sortable: false,
          value: "description"
        },
        { text: "STATUS", align: "center", sortable: false, value: "status" },
        { text: "VENDOR", align: "center", sortable: false, value: "vendor" },
        {
          text: "SUBMITTED",
          align: "center",
          sortable: false,
          value: "submitted"
        },
        {
          text: "RISK RATING",
          align: "center",
          sortable: false,
          value: "risk_rating"
        },
        { text: "REPORT", align: "center", sortable: false, value: "report" }
      ],
      riskOptions: {
        labels: ["Critical", "High", "Medium", "Low"],
        colors: ["#d5132f", "#ff6600", "#fec02d", "#2bb9aa"],
        fill: {
          colors: ["#d5132f", "#ff6600", "#fec02d", "#2bb9aa"]
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 310
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      // vendors: [44, 55, 41, 17, 15],
      vendors: [],
      vendorOptions: {
        labels: [],
        colors: [],
        fill: {
          colors: []
        },
        // labels: ["Vendor1", "Vendor2", "Vendor3", "Vendor4", "Vendor5"],
        // colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"],
        // fill: {
        //   colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"]
        // },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 310
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      showgraph: true,
      alert: "",
      deletedialog: false,
      deletedialog_mobile: false,
      sharedialog: false,
      sharedialog_mobile: false,
      emailRule: [
        v => !!v || "Email is required",
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Invalid e-mail.";
        }
      ],
      email: "",
      valid: false,
      criticalCount: 0,

      shareemails: "",
      sharestatus: "",

      loading: true
    };
  },
  mounted() {
    this.loading = true;
    this.$store.dispatch("getAllAnalysis").then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
    this.$store.dispatch("getOverRisk").then(response => {
      response.data.map(item => {
        if (item.risk_rating == 1) {
          this.criticalCount = item.count;
        }
      });
    });
    this.$store.dispatch("getVendors").then(response => {
      let vendor_array = [];
      let count_array = [];
      response.data.map(item => {
        vendor_array.push(item.vendor_upper);
        count_array.push(item.count);
      });
      this.vendors = count_array;
      this.vendorOptions = {
        labels: vendor_array,
        colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"],
        fill: {
          colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"]
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 310
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      };
    });
  },
  computed: {
    items() {
      return this.$store.state.analysis.all;
    },
    risks() {
      return this.$store.state.analysis.risks;
    },
    profile() {
      return this.$store.state.user.profile;
    },
  },
  methods: {
    expandOnDesktop(event) {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement
          : event.target.parentElement.parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.click();
    },
    expandOnMobile(event) {
      let parent_row =
        event.target.tagName == "svg"
          ? event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement
          : event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement.parentElement;
      parent_row.firstElementChild.firstElementChild.lastElementChild.firstElementChild.click();
    },
    ShowGraph() {
      this.showgraph = this.showgraph == true ? false : true;
      if (this.showgraph == true) {
        let itag = document.querySelector(".analysis .down");
        itag.style.transform = "none";
        itag.style.transition = "all 0.6s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      } else {
        let itag = document.querySelector(".analysis .down");
        itag.style.transform = "rotate(180deg)";
        itag.style.transition = "all 0.6s cubic-bezier(0.25, 0.8, 0.5, 1) 0s";
      }
    },
    deleteAnalysis(item) {
      let analysisID = item.id;
      this.$store
        .dispatch("deleteAnalysis", {
          id: analysisID
        })
        .then(response => {
          this.$store.dispatch("getAllAnalysis");
          this.$store.dispatch("getOverRisk").then(response => {
            response.data.map(item => {
              if (item.risk_rating == 1) {
                this.criticalCount = item.count;
              }
            });
          });
          this.$store.dispatch("getVendors").then(response => {
            let vendor_array = [];
            let count_array = [];
            response.data.map(item => {
              vendor_array.push(item.vendor_upper);
              count_array.push(item.count);
            });
            this.vendors = count_array;
            this.vendorOptions = {
              labels: vendor_array,
              colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"],
              fill: {
                colors: ["#249C88", "#63C7BB", "#0D8973", "#90D3CB", "#2BAD9A"]
              },
              responsive: [
                {
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 310
                    },
                    legend: {
                      position: "bottom"
                    }
                  }
                }
              ]
            };
          });
        })
        .then(response => {
          this.alert =
            response.status == 204
              ? "The analysis is deleted successfully"
              : "Delete Failure";
        });
    },
    shareReport(item) {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.sharestatus = "sharing...";
      const data = {
        email: this.shareemails,
        analysis_id: item.id
      };
      this.$store.dispatch("shareReport", data).then(response => {
        this.sharestatus = response.data.status
      }).catch(error => {
        this.sharestatus = error.response.data.status
      });
    },
    addList(email) {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.emails.push(email);
    }
  }
};
</script>
